import {
  GET_BUYER_CATEGORIES_SUCCESS,
  GET_BUYER_CATEGORIES_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_BUYER_CATEGORIES_SUCCESS: {
      return {
        ...state,
        buyerCategories: action.payload.buyerCategories,
      }
    }

    case GET_BUYER_CATEGORIES_FAILURE: {
      return {
        ...state,
        getBuyerCategoriesError: action.payload.error,
      }
    }

    default:
      return state
  }
}
